import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'a5864e3f-1850-4fc6-8c79-54c68612311f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -631,
      y: -373,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.98,
        y: 0.98
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'base',
      parent: 'd6cf9781-63c5-4e2b-9c68-8700bcbbe6c7',
      data: ''
    },
    {
      id: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 65,
      y: 148,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'splash_harvest',
      parent: 'a5864e3f-1850-4fc6-8c79-54c68612311f',
      data: ''
    },
    {
      id: 'e8436f0b-2725-4eb3-bdbd-3e39b3a48e1c',
      type: 'Sprite',
      name: 'ad_btn',
      nameSpace: '',
      className: '',
      x: 398,
      y: 701,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_purple',
      parent: 'a5864e3f-1850-4fc6-8c79-54c68612311f',
      data: ''
    },
    {
      id: '8bc1cef6-13c4-4c96-b57d-6796e1cf101c',
      type: 'Sprite',
      name: 'collect_btn',
      nameSpace: '',
      className: '',
      x: 933,
      y: 701,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: 'a5864e3f-1850-4fc6-8c79-54c68612311f',
      data: ''
    },
    {
      id: 'd9ae67b1-b4c7-4530-aece-8f46eaf53c7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 372,
      y: -10,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: 'a5864e3f-1850-4fc6-8c79-54c68612311f',
      data: ''
    },
    {
      id: '86844031-d3a7-4380-acd1-51af1e59dfbe',
      type: 'Sprite',
      name: 'exit_btn',
      nameSpace: '',
      className: '',
      x: 1188,
      y: 110,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: 'a5864e3f-1850-4fc6-8c79-54c68612311f',
      data: ''
    },
    {
      id: '1ac29add-508b-4ae6-a580-be2e598a9bb4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 170,
      y: 94,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'harvest_coin_bg',
      parent: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      data: ''
    },
    {
      id: '31ea481a-1391-416f-b16d-ca20348db2ab',
      type: 'Sprite',
      name: 'divider',
      nameSpace: '',
      className: '',
      x: 648,
      y: 261,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'splash_harvest_2',
      parent: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      data: ''
    },
    {
      id: 'ddd24f3b-527a-4f34-9dd3-f0901ab5c853',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 322,
      y: 79,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'CollectHarvest',
      localize: true,
      maxWidth: 582,
      maxHeight: 108,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#3b3b3b',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 582,
        breakWords: false,
        lineHeight: 45,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      data: ''
    },
    {
      id: '59b9d172-0dd2-495e-8a8d-e6b66cf48996',
      type: 'Sprite',
      name: 'harvest_reward_frame_content',
      nameSpace: '',
      className: '',
      x: 664,
      y: 298,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_map_11',
      parent: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      data: ''
    },
    {
      id: '86e6bca1-95e2-464a-bd98-a87e55b3b308',
      type: 'Container',
      name: 'layout_3',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      data: ''
    },
    {
      id: '40cf405f-4ed3-49c7-b2da-ac9b021c84a7',
      type: 'Container',
      name: 'layout_2',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      data: ''
    },
    {
      id: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      type: 'Container',
      name: 'layout_1',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4e185be3-a62c-409e-9f24-a9be85af96d6',
      data: ''
    },
    {
      id: 'c45e7791-6301-49dc-97b6-da644be204ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -164,
      y: -93,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'ad_icon_2',
      parent: 'e8436f0b-2725-4eb3-bdbd-3e39b3a48e1c',
      data: ''
    },
    {
      id: '1cbde957-1d6c-4a5b-a59e-7d6c4b66fccf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 102,
      y: -115,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'double_harvest_bg',
      parent: 'e8436f0b-2725-4eb3-bdbd-3e39b3a48e1c',
      data: ''
    },
    {
      id: 'e5b415c4-5d64-43d2-9179-3291a2005293',
      type: 'Text',
      name: 'ad_btn_text',
      nameSpace: '',
      className: '',
      x: -2,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collectx2',
      localize: true,
      maxWidth: 217,
      maxHeight: 92,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 49,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8c0154',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e8436f0b-2725-4eb3-bdbd-3e39b3a48e1c',
      data: ''
    },
    {
      id: 'f2d1c8e9-4c5a-47df-9e6b-f9b985e18f7e',
      type: 'Text',
      name: 'harvest_btn_text',
      nameSpace: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Collect',
      localize: true,
      maxWidth: 217,
      maxHeight: 93,
      maxFontSize: 49,
      icons: [],
      style: {
        fontSize: 49,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#187630',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8bc1cef6-13c4-4c96-b57d-6796e1cf101c',
      data: ''
    },
    {
      id: '5f46edc6-e074-4e84-a60c-6baa96dc4466',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 279,
      y: 71,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Harvest',
      localize: true,
      maxWidth: 431,
      maxHeight: 89,
      maxFontSize: 44,
      icons: [],
      style: {
        fontSize: 44,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#ab3143',
        strokeThickness: 5,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'd9ae67b1-b4c7-4530-aece-8f46eaf53c7a',
      data: ''
    },
    {
      id: 'ada1892c-faf6-4e0c-ad7e-7f35cf072f80',
      type: 'Text',
      name: 'harvest_income_text',
      nameSpace: '',
      className: '',
      x: 159,
      y: 71,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '5050',
      localize: false,
      maxWidth: 141,
      maxHeight: 63,
      maxFontSize: 42,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#8d231b',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0.52,
        dropShadowBlur: 5,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '1ac29add-508b-4ae6-a580-be2e598a9bb4',
      data: ''
    },
    {
      id: 'f1230534-2264-47cf-b551-60cff077a9b8',
      type: 'Sprite',
      name: 'crop_3_4',
      nameSpace: '',
      className: '',
      x: 915,
      y: 156,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '86e6bca1-95e2-464a-bd98-a87e55b3b308',
      data: ''
    },
    {
      id: '56d67f1e-242c-426e-8904-2649d3693cac',
      type: 'Sprite',
      name: 'crop_3_3',
      nameSpace: '',
      className: '',
      x: 715,
      y: 156,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '86e6bca1-95e2-464a-bd98-a87e55b3b308',
      data: ''
    },
    {
      id: 'bb84b63a-d2d4-420e-a02f-ae4f7722fcf5',
      type: 'Sprite',
      name: 'crop_3_2',
      nameSpace: '',
      className: '',
      x: 915,
      y: 35,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '86e6bca1-95e2-464a-bd98-a87e55b3b308',
      data: ''
    },
    {
      id: 'a64cce94-fd34-4175-818a-7f71b7790f89',
      type: 'Sprite',
      name: 'crop_3_1',
      nameSpace: '',
      className: '',
      x: 715,
      y: 35,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '86e6bca1-95e2-464a-bd98-a87e55b3b308',
      data: ''
    },
    {
      id: 'b8e98437-e559-473f-a26e-2269524ae5e4',
      type: 'Sprite',
      name: 'crop_2_6',
      nameSpace: '',
      className: '',
      x: 958,
      y: 154,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '40cf405f-4ed3-49c7-b2da-ac9b021c84a7',
      data: ''
    },
    {
      id: '2708d9ec-0cba-4126-bcd3-2f88abc6eabf',
      type: 'Sprite',
      name: 'crop_2_5',
      nameSpace: '',
      className: '',
      x: 812,
      y: 159,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '40cf405f-4ed3-49c7-b2da-ac9b021c84a7',
      data: ''
    },
    {
      id: '4537b019-a780-4da5-9494-552d5858c671',
      type: 'Sprite',
      name: 'crop_2_4',
      nameSpace: '',
      className: '',
      x: 666,
      y: 157,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '40cf405f-4ed3-49c7-b2da-ac9b021c84a7',
      data: ''
    },
    {
      id: 'f6b9b956-f78e-49df-8d9f-d9f77e8443da',
      type: 'Sprite',
      name: 'crop_2_3',
      nameSpace: '',
      className: '',
      x: 958,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '40cf405f-4ed3-49c7-b2da-ac9b021c84a7',
      data: ''
    },
    {
      id: 'd7b873ac-7a07-4259-a99b-dcf3b63d57ef',
      type: 'Sprite',
      name: 'crop_2_2',
      nameSpace: '',
      className: '',
      x: 806,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '40cf405f-4ed3-49c7-b2da-ac9b021c84a7',
      data: ''
    },
    {
      id: 'f8ddcb69-590b-4f97-b0c6-6453e17bd21c',
      type: 'Sprite',
      name: 'crop_2_1',
      nameSpace: '',
      className: '',
      x: 656,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_82_2',
      parent: '40cf405f-4ed3-49c7-b2da-ac9b021c84a7',
      data: ''
    },
    {
      id: '96d01fff-d42b-43ec-847b-b7a5e6193465',
      type: 'Sprite',
      name: 'crop_1_7',
      nameSpace: '',
      className: '',
      x: 957,
      y: 210,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_7_3',
      parent: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      data: ''
    },
    {
      id: '90b47e6d-bdba-47ad-9036-9539a0ad4514',
      type: 'Sprite',
      name: 'crop_1_6',
      nameSpace: '',
      className: '',
      x: 812,
      y: 163,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_6_3',
      parent: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      data: ''
    },
    {
      id: '76cc9f5c-056b-4181-a236-0174d23bf4ba',
      type: 'Sprite',
      name: 'crop_1_5',
      nameSpace: '',
      className: '',
      x: 765,
      y: 284,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_5_3',
      parent: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      data: ''
    },
    {
      id: '5e8166ff-c5e6-4301-95c2-3bb56cd71796',
      type: 'Sprite',
      name: 'crop_1_4',
      nameSpace: '',
      className: '',
      x: 650,
      y: 228,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_4_3',
      parent: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      data: ''
    },
    {
      id: 'd46fa80a-aba9-4166-990b-566690f3e899',
      type: 'Sprite',
      name: 'crop_1_3',
      nameSpace: '',
      className: '',
      x: 912,
      y: 63,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_3_3',
      parent: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      data: ''
    },
    {
      id: 'b16b349a-0541-479a-8f2b-f7e10c2d9d74',
      type: 'Sprite',
      name: 'crop_1_2',
      nameSpace: '',
      className: '',
      x: 783,
      y: 58,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_2_3',
      parent: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      data: ''
    },
    {
      id: '88bf6f52-4e3e-4d4a-86df-344575069e46',
      type: 'Sprite',
      name: 'crop_1_1',
      nameSpace: '',
      className: '',
      x: 642,
      y: 49,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'collect_1_3',
      parent: '99132bc4-c271-46dd-ba5c-b63863979b1d',
      data: ''
    },
    {
      id: '0c073863-bffc-40b4-94e9-98af90c0aa3a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 117,
      y: 43,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'double_harvest_coin_label',
      parent: '1cbde957-1d6c-4a5b-a59e-7d6c4b66fccf',
      data: ''
    },
    {
      id: 'b061651c-901e-42a3-a6a4-d7dfc72a8efc',
      type: 'Text',
      name: 'ad_harvest_income_text',
      nameSpace: '',
      className: '',
      x: 80,
      y: 75,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -17,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10100',
      localize: false,
      maxWidth: 85,
      maxHeight: 47,
      maxFontSize: 26,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#0562b0',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '1cbde957-1d6c-4a5b-a59e-7d6c4b66fccf',
      data: ''
    },
    {
      id: '0859b4c8-5c75-436f-8a16-eece3e9f2b94',
      type: 'Text',
      name: 'crop_text_3_4',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f1230534-2264-47cf-b551-60cff077a9b8',
      data: ''
    },
    {
      id: '43fd45d8-74bb-4df1-a655-c3a65abbad82',
      type: 'Text',
      name: 'crop_text_3_3',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '56d67f1e-242c-426e-8904-2649d3693cac',
      data: ''
    },
    {
      id: 'fe94e251-a7d7-4a59-a150-8073f5352d82',
      type: 'Text',
      name: 'crop_text_3_2',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'bb84b63a-d2d4-420e-a02f-ae4f7722fcf5',
      data: ''
    },
    {
      id: '45355c0a-a45b-4674-9298-d666a6b3307c',
      type: 'Text',
      name: 'crop_text_3_1',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a64cce94-fd34-4175-818a-7f71b7790f89',
      data: ''
    },
    {
      id: '3f30cd3b-1670-4e94-ae14-019dc280b3ca',
      type: 'Text',
      name: 'crop_text_2_6',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b8e98437-e559-473f-a26e-2269524ae5e4',
      data: ''
    },
    {
      id: '77ae1faf-6c09-4fd8-8afa-ac557c5bd8ad',
      type: 'Text',
      name: 'crop_text_2_5',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '2708d9ec-0cba-4126-bcd3-2f88abc6eabf',
      data: ''
    },
    {
      id: 'f7974ce8-8aed-41da-b8a3-45cdc7af9f2f',
      type: 'Text',
      name: 'crop_text_2_4',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '4537b019-a780-4da5-9494-552d5858c671',
      data: ''
    },
    {
      id: 'f5846a31-1a55-40a0-8a92-86940e572d29',
      type: 'Text',
      name: 'crop_text_2_3',
      nameSpace: '',
      className: '',
      x: 13,
      y: 34,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f6b9b956-f78e-49df-8d9f-d9f77e8443da',
      data: ''
    },
    {
      id: 'ad9f82d4-361a-476b-8fd8-84ba4fa7c9cd',
      type: 'Text',
      name: 'crop_text_2_2',
      nameSpace: '',
      className: '',
      x: 14,
      y: 40,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'd7b873ac-7a07-4259-a99b-dcf3b63d57ef',
      data: ''
    },
    {
      id: '9d57a82b-7b46-4a31-85ba-3c323c13504a',
      type: 'Text',
      name: 'crop_text_2_1',
      nameSpace: '',
      className: '',
      x: 17,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f8ddcb69-590b-4f97-b0c6-6453e17bd21c',
      data: ''
    },
    {
      id: '82d614d9-f411-49fb-af26-74fdead68e65',
      type: 'Text',
      name: 'crop_text_1_7',
      nameSpace: '',
      className: '',
      x: 6,
      y: 56,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '96d01fff-d42b-43ec-847b-b7a5e6193465',
      data: ''
    },
    {
      id: 'c11a6489-fe4c-4340-b22e-c4868a90916b',
      type: 'Text',
      name: 'crop_text_1_6',
      nameSpace: '',
      className: '',
      x: -2,
      y: 36,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '90b47e6d-bdba-47ad-9036-9539a0ad4514',
      data: ''
    },
    {
      id: '4040351f-d51d-43da-9913-bcc3273e266a',
      type: 'Text',
      name: 'crop_text_1_5',
      nameSpace: '',
      className: '',
      x: 54,
      y: 47,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '76cc9f5c-056b-4181-a236-0174d23bf4ba',
      data: ''
    },
    {
      id: '1293ee8d-fcae-42c1-8b24-4aed5d241dd1',
      type: 'Text',
      name: 'crop_text_1_4',
      nameSpace: '',
      className: '',
      x: 8,
      y: 34,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5e8166ff-c5e6-4301-95c2-3bb56cd71796',
      data: ''
    },
    {
      id: '13f34dc7-16d3-4d70-8e6f-a11e27fe12bf',
      type: 'Text',
      name: 'crop_text_1_3',
      nameSpace: '',
      className: '',
      x: 39,
      y: 53,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'd46fa80a-aba9-4166-990b-566690f3e899',
      data: ''
    },
    {
      id: 'baec493b-7577-4db5-86eb-522effc4f3b3',
      type: 'Text',
      name: 'crop_text_1_2',
      nameSpace: '',
      className: '',
      x: 10,
      y: 34,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b16b349a-0541-479a-8f2b-f7e10c2d9d74',
      data: ''
    },
    {
      id: 'b6135fad-40c5-48b0-8f95-36edffa28bf8',
      type: 'Text',
      name: 'crop_text_1_1',
      nameSpace: '',
      className: '',
      x: 12,
      y: 72,
      anchor: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 2325',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#e0e2bc',
        stroke: '#013220',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '88bf6f52-4e3e-4d4a-86df-344575069e46',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class FieldHarvestLayout {
  static raw = raw;
  root: PIXI.Container
  harvest_income_text: PIXI.Text
  divider: PIXI.Sprite
  harvest_reward_frame_content: PIXI.Sprite
  layout_3: PIXI.Container
  crop_3_4: PIXI.Sprite
  crop_text_3_4: PIXI.Text
  crop_3_3: PIXI.Sprite
  crop_text_3_3: PIXI.Text
  crop_3_2: PIXI.Sprite
  crop_text_3_2: PIXI.Text
  crop_3_1: PIXI.Sprite
  crop_text_3_1: PIXI.Text
  layout_2: PIXI.Container
  crop_2_6: PIXI.Sprite
  crop_text_2_6: PIXI.Text
  crop_2_5: PIXI.Sprite
  crop_text_2_5: PIXI.Text
  crop_2_4: PIXI.Sprite
  crop_text_2_4: PIXI.Text
  crop_2_3: PIXI.Sprite
  crop_text_2_3: PIXI.Text
  crop_2_2: PIXI.Sprite
  crop_text_2_2: PIXI.Text
  crop_2_1: PIXI.Sprite
  crop_text_2_1: PIXI.Text
  layout_1: PIXI.Container
  crop_1_7: PIXI.Sprite
  crop_text_1_7: PIXI.Text
  crop_1_6: PIXI.Sprite
  crop_text_1_6: PIXI.Text
  crop_1_5: PIXI.Sprite
  crop_text_1_5: PIXI.Text
  crop_1_4: PIXI.Sprite
  crop_text_1_4: PIXI.Text
  crop_1_3: PIXI.Sprite
  crop_text_1_3: PIXI.Text
  crop_1_2: PIXI.Sprite
  crop_text_1_2: PIXI.Text
  crop_1_1: PIXI.Sprite
  crop_text_1_1: PIXI.Text
  ad_btn: PIXI.Sprite
  ad_harvest_income_text: PIXI.Text
  ad_btn_text: PIXI.Text
  collect_btn: PIXI.Sprite
  harvest_btn_text: PIXI.Text
  exit_btn: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
